jQuery(document).ready(function ($) {
    $.fn.restart = function () {
        const _this = this;

        dataLayer.push({
            event: 'restart_calculator'
        });

        $.ajax({
            url: arise_pc.ajax_url,
            type: 'POST',
            data: {
                action: 'arise_pc_reset_block',
                nonce: arise_pc.nonce
            },

            beforeSend: function () {
                _this.closest('.pricing-calculator__results').addClass('loading');
            },

            success: function (response) {
                window.arise_pc_state.services = [];
                window.arise_pc_state.current_response = false;
                window.arise_pc_state.next_question = -1;

                const container = _this.closest('.pricing-calculator__container');
                const calculator = container.closest('.pricing-calculator');

                container.html('');
                container.append(response.data.block);

                calculator.attr('data-services', '');
                window.arise_pc_set_step(1, calculator);

                $('html, body').animate({ scrollTop: calculator.offset().top - ($('.heading-links').outerHeight() || 0) }, 250);
            },

            complete: function () {
                _this.closest('.pricing-calculator__results').removeClass('loading');
            }
        });
    }

    $(document).on('click', '#pc-restart', function (event) {
        event.preventDefault();

        $(this).restart();
    });
});